import config from '../config'
import client from './client'

const endpoint = 'admin/cms/'

//PAGINA
const creaPagina = (nome, link) => {
  return client.post(config.serverUrl + endpoint + 'pagina', { nome, link })
}
const modificaPagina = (pagina) => {
  return client.put(config.serverUrl + endpoint + 'pagina', pagina)
}
const eliminaPagina = (id) => {
  return client.delete(config.serverUrl + endpoint + 'pagina/' + id)
}

//ELEMENTO
const creaElemento = (elemento, componenti) => {
  return client.post(config.serverUrl + endpoint + 'elemento', {
    elemento,
    componenti,
  })
}
const modificaElemento = (elemento, componenti, eliminati) => {
  return client.put(config.serverUrl + endpoint + 'elemento', {
    elemento,
    componenti,
    eliminati,
  })
}
const eliminaElemento = (id) => {
  return client.delete(config.serverUrl + endpoint + 'elemento/' + id)
}

//COMPONENTI
const modificaComponenti = (idElemento, componenti) => {
  return client.put(config.serverUrl + endpoint + 'componenti', {
    idElemento,
    componenti,
  })
}

//FAQ
const modificaFaq = (idPagina, payload) => {
  return client.put(config.serverUrl + endpoint + 'pagina/faq', {
    id: idPagina,
    faq_abilitato: payload.faq_abilitato,
    faq: payload.faq,
  })
}

const getFaq = (parentType, parentId) => {
  return client.get(
    config.serverUrl + endpoint + 'faq?parent_type=' + encodeURIComponent(parentType) + '&parent_id=' + parentId
  )
}

const modificaFaqPolymorphic = (payload) => {
  return client.put(config.serverUrl + endpoint + 'faq', {
    parent_type: payload.parent_type,
    parent_id: payload.parent_id,
    faq_abilitato: payload.faq_abilitato,
    faq: payload.faq,
  })
}

export default {
  creaPagina,
  modificaPagina,
  eliminaPagina,
  creaElemento,
  modificaElemento,
  eliminaElemento,
  modificaComponenti,
  modificaFaq,
  getFaq,
  modificaFaqPolymorphic,
}
